const getResourceGenericName = (resource) => {
  switch (resource.kind) {
    case "bookmark":
      return "saved link";
    case "highlight":
      return "saved highlight";
    case "image":
      return "saved image";
    case "notepad":
      return "note";
    case "folder":
      return "folder";
    case "audio":
      return "audio";
    case "video":
      return "video";
    case "document": {
      if (resource.mimeType?.startsWith("application/pdf")) {
        return "PDF";
      } else {
        return "document";
      }
    }
    default:
      return "item";
  }
};

export { getResourceGenericName };
//# sourceMappingURL=getResourceGenericName.js.map
